/**
 * 视频播放
 */
import React from 'react';
import { component_tool } from '@/tool'

const { WizComponent, WizModal } = component_tool;

import './index.less'
export default class ModalPlayer extends WizComponent {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    let { visible = false, videoUrl = '', setVisible, width = '30%', title = '视频播放' } = this.props
    const modalProps = {
      visible,
      title,
      footer: null,
      width,
      onCancel: () => { setVisible() },
    };
    return (
      <WizModal {...modalProps}>
        <div className='video-style'>
          <video src={getOssFilePath(videoUrl)} controls={'controls'} preload={'preload'} />
        </div>
      </WizModal>
    )
  }

}